"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSize = exports.cardSizes = exports.defaultVariant = exports.cardVariants = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = require("react");
const Heading_1 = __importDefault(require("../Heading"));
const card_module_scss_1 = __importDefault(require("./card.module.scss"));
exports.cardVariants = [
    'primary',
    'secondary',
    'info',
    'transparent',
    'ternary',
    'outlined',
];
exports.defaultVariant = 'primary';
exports.cardSizes = ['xxs', 'xs', 'sm', 'md', 'lg', 'xl'];
exports.defaultSize = 'md';
function Card(_a, ref) {
    var { variant = exports.defaultVariant, size = exports.defaultSize, children, className, disableElevation, fullWidth, heading, headingProps, active = false, justify } = _a, props = __rest(_a, ["variant", "size", "children", "className", "disableElevation", "fullWidth", "heading", "headingProps", "active", "justify"]);
    return ((0, jsx_runtime_1.jsxs)("article", Object.assign({}, props, { className: (0, classnames_1.default)(className, card_module_scss_1.default.container, card_module_scss_1.default[`variant_${variant}`], card_module_scss_1.default[`size_${size}`], {
            [card_module_scss_1.default.disableElevation]: disableElevation,
            [card_module_scss_1.default.fullWidth]: fullWidth,
            [card_module_scss_1.default.active]: active,
            [card_module_scss_1.default[`justify_${justify}`]]: justify,
            [card_module_scss_1.default.clickable]: typeof props.onClick == 'function',
        }), ref: ref, children: [heading && ((0, jsx_runtime_1.jsx)(Heading_1.default, Object.assign({ as: "h2", fontSize: "md", className: card_module_scss_1.default.heading }, headingProps, { children: heading }))), children] })));
}
exports.default = (0, react_1.forwardRef)(Card);
